import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationFR from './locales/fr/translation.json';
import translationAR from './locales/ar/translation.json';
import translationEN from './locales/en/translation.json';

import Cookies from 'universal-cookie';

const cookies = new Cookies().get('language');

const resources = {
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
  en: {
    translation: translationEN,
  },
};
i18n.use(initReactI18next).init({
  resources,
  lng: cookies ? cookies : 'en',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
